__turbopack_context__.v({
  "floating-btn": "FloatingButton-module-scss-module__ZD8ktG__floating-btn",
  "floating-btn-resize-forward": "FloatingButton-module-scss-module__ZD8ktG__floating-btn-resize-forward",
  "floating-btn-resize-reverse": "FloatingButton-module-scss-module__ZD8ktG__floating-btn-resize-reverse",
  "resize-movement-forward": "FloatingButton-module-scss-module__ZD8ktG__resize-movement-forward",
  "resize-movement-reverse": "FloatingButton-module-scss-module__ZD8ktG__resize-movement-reverse",
  "visible": "FloatingButton-module-scss-module__ZD8ktG__visible",
});
